export default function MySQL_DEGREES() {
  return (
    <div>
      <h2>MySQL_DEGREES</h2>    </div>
  );
}